import React from 'react'

const CampeggiContext = React.createContext()

export default CampeggiContext
